import { forwardRef } from "react";
import DataGrid, {
  Column,
  DataGridRef,
  Pager,
  Paging,
  RemoteOperations,
  StateStoring,
} from "devextreme-react/data-grid";
import { GridType } from "../../types/types";

const GridCreator = forwardRef<DataGridRef, GridType<any, any>>(
  ({ stateStoring, columns, remoteOperationsConfig, toolbar, paging, pager, ...props }, ref) => {
    return (
      <DataGrid ref={ref} {...props} className={"system-data-grid"}>
        {toolbar && toolbar()}
        {columns?.map((item) => {
          return <Column key={item.dataField} {...item} />;
        })}
        {stateStoring && <StateStoring {...stateStoring} />}
        {paging && <Paging {...paging} />}
        {pager && <Pager {...pager} />}
        {remoteOperationsConfig && <RemoteOperations {...remoteOperationsConfig} />}
      </DataGrid>
    );
  }
);

export default GridCreator;
